// Returns current UTC date
const MILLISECONDS_PER_MINUTE = 60 * 1000;

export const getUTCDate = () => {
  const today = new Date();
  const UTCMinutesOffset = today.getTimezoneOffset();

  return new Date(today.getTime() + UTCMinutesOffset * MILLISECONDS_PER_MINUTE);
};
